import { useEffect, useRef } from 'react'

import { setABTestsCookie, updateABTestsCookie } from '@core/abTesting'
import { add95PercentTrafficTest } from '@core/abTesting/add95PercentTrafficTest'
import { type Channel } from '@core/channel'
import { useSubscriptionFlags } from '@embed/hooks/subscriptionFlags/useSubscriptionFlags'

/**
 * Check subscription flags for 95_percent_traffic_widget_display
 * and handle any corresponding cookies
 */
export const use95PercentTraffic = (channel: Channel | null) => {
  const subscriptionFlags = useSubscriptionFlags(channel)
  const testAddedRef = useRef(false)

  useEffect(() => {
    if (channel) {
      if (subscriptionFlags['95_percent_traffic_widget_display']) {
        if (!testAddedRef.current) {
          add95PercentTrafficTest()
          testAddedRef.current = true
        }
        setABTestsCookie()
      } else {
        updateABTestsCookie()
      }
    }
  }, [channel, subscriptionFlags])
}
